// removed by extract-text-webpack-plugin
module.exports = {"Card":"_1hAOzr4F-IcL-zDe0ANKDq","Header":"_3UJx3bBotnBc7QkR7DDQxe","Title":"kpKUCXaEaJtjLxP87aBo","Btn":"_2rgtnJq3ymkbfgGNFENeO6","IconLeft":"_1WTu9vjnWPxdOsEmyJMjYX","PaginationWrap":"_2BlhjLGsPYvQakNL7_FGV3","ActiveLink":"_3AFJ4cscRmA9JZwiXBGBo9"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfAdministrator/Ptojects/styles.module.css
// module id = 615
// module chunks = 0